//定位
import { HOST } from "./../../../../../config/config.js";
import $request from './../../../../../utils/request.js';

//获取微信签名
export function get_wx_sign($mapStore,$wx,callback) {

    // /api/v1/jsticket (正式服)

    $request.get(HOST + "/api/v1/jsticket?appId="+$mapStore.plugInfo.appId+'&url='+location.href.split('#')[0]).then((res)=>{

        res=res.data.data;

        // 开启微信接口
        $wx.config({
            debug:false,
            appId: res.appId,					//必填
            timestamp: res.timestamp,			//必填
            nonceStr: res.nonceStr,			//必填
            signature: res.signature,			//必填
            jsApiList:[
                'startSearchBeacons',		//必填
                'stopSearchBeacons',		//必填
                'onSearchBeacons',			//必填
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
                'startRecord',
                'stopRecord',
                'onVoiceRecordEnd',
                'playVoice',
                'pauseVoice',
                'stopVoice',
                'onVoicePlayEnd',
                'uploadVoice',
                'downloadVoice',
                "getLocation",
                "openLocation"
            ]
        });

        //执行回调
        $wx.ready(()=>{
            callback?(callback&&callback()):'';
        })

    }).catch((res)=>{
        console.log('获取签名失败',res);
    })

}

//停止扫描
export function stopSearchBeacons($wx,callback) {
    $wx.stopSearchBeacons({
        complete:function(){
            callback?(callback&&callback()):'';
        }
    });
}

//开启扫描
export function startSearchBeacons($wx,callback) {

    //先停止扫描
    $wx.stopSearchBeacons({

        complete:function(res){

            setTimeout(()=>{

                //再开启扫描
                $wx.startSearchBeacons({
                    ticket: "",
                    complete: function(res){
                        callback?(callback&&callback(res)):'';
                    }
                });

            },1000)
        }
    })

}


//开启监听设备
export function startonSearchBeacons($wx,callback) {
    $wx.onSearchBeacons({
        complete:function (argv) {
            callback?(callback&&callback(argv)):'';
        }
    })
}
